import { parseRichTextContent } from 'src/utils/parseRichTextContent'

import Section from '../Section'
import './rich-text.scss'

type TRichText = {
  textTitle?: string
  richText: string
}

const RichText = ({ textTitle, richText }: TRichText) => {
  const parsedRichText = parseRichTextContent(richText)

  return (
    <Section className="layout__section layout__content rich-text-container">
      <div className="rich-text-title-container">
        <h1 className="rich-text-title">{textTitle}</h1>
      </div>
      <div
        className="rich-text-content"
        dangerouslySetInnerHTML={{ __html: parsedRichText }}
      />
    </Section>
  )
}

export default RichText
